import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";

import "./css/reuniao.css";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import DataUtil from "../../../actions/data";

import CadastroTopico from "./CadastroTopico";
import CadastroObservacao from "./CadastroObservacao";
import CadastroDocumento from "./CadastroDocumento";

class CadastroReuniao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioId: this.props.usuario.id,
      reuniao: this.getInitialState(),
      usuarios: [],
      procedimentos: [],
    };
    if (this.props.match.params.id) {
      this.state.reuniao.id = this.props.match.params.id;
    }

    this.getInitialState = this.getInitialState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeReuniao = this.handleChangeReuniao.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.adicionarValor = this.adicionarValor.bind(this);
    this.removerValor = this.removerValor.bind(this);
    this.adicionarTopico = this.adicionarTopico.bind(this);
    this.alterarTopico = this.alterarTopico.bind(this);
    this.removerTopico = this.removerTopico.bind(this);
    this.uploaded = this.uploaded.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      usuarioId: 0,
      procedimentoId: -1,
      data: DataUtil.hoje(),
      horaEntrada: "00:00",
      horaSaida: "00:00",
      pauta: "",
      unidade: 1,
      valorReceber: "0.00",
      dataPagamento: "",
      observacoes: "",
      tipo: 1,
      valores: [],
      topicos: [{ descricao: "Digite aqui o assunto discutido..." }],
    };
  }

  // Atualizar a pagina quando estiver nessa rota
  componentWillReceiveProps() {
    window.scrollTo(0, 0);
    let initial = this.getInitialState();
    initial.procedimentoId =
      this.state.procedimentos.length > 0
        ? this.state.procedimentos[0].id
        : null;
    initial.unidade =
      this.state.procedimentos.length > 0
        ? this.state.procedimentos[0].unidade
        : 1;
    this.setState({ reuniao: initial });
  }

  componentDidMount() {
    UI.loader("show", "Um momento...");
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários à vincular ...
        let usuarios = json.data;
        let state = this.state;
        //state.usuarioId = usuarios[0].id;

        API.get("/procedimentos/reuniao").then(
          function (json) {
            // Cria uma lista simplificada de atividades à vincular ...
            let procedimentos = json.data;
            let reuniao = state.reuniao;
            reuniao.procedimentoId =
              procedimentos.length > 0 ? procedimentos[0].id : null;
            reuniao.unidade =
              procedimentos.length > 0 ? procedimentos[0].unidade : 1;

            // Se não houver procedimentos cadastrados não é possível continuar
            if (procedimentos.length === 0) {
              UI.alert(
                false,
                "Não há nenhum procedimento cadastrado, verifique."
              );
              UI.loader("hide");
              return;
            }

            this.setState({
              reuniao: reuniao,
              usuarios: usuarios,
              procedimentos: procedimentos,
            });

            // Selecionar automaticamente o profissional
            let id = parseInt(this.state.reuniao.id);
            if (id === 0) {
              this.adicionarValor();
            }

            // Carrega a reunião selecionado para edição
            id = parseInt(reuniao.id);
            if (id !== 0) {
              UI.loader("show", "Um momento...");
              API.get("/reunioes/" + id)
                .then(
                  function (json) {
                    if (!json.data.dataPagamento) json.data.dataPagamento = "";
                    this.setState({ reuniao: json.data });
                    UI.loader("hide");
                  }.bind(this)
                )
                .catch(function (json) {
                  UI.alert(false, json.message);
                  UI.loader("hide");
                });
            } else {
              UI.loader("hide");
            }
          }.bind(this)
        );
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    let data = this.state.reuniao;

    // Jackson não deserializa horário sem segundos
    data.horaEntrada = data.horaEntrada.substr(0, 5) + ":00";
    data.horaSaida = data.horaSaida.substr(0, 5) + ":00";

    if (data.valores.length === 0) {
      UI.alert(false, "Os profissionais não foram selecionados.");
      return;
    } else if (!DataUtil.validarHora(data.horaEntrada)) {
      UI.alert(false, "Preencha corretamente a hora de entrada da reunião.");
      return;
    } else if (!DataUtil.validarHora(data.horaSaida)) {
      UI.alert(false, "Preencha corretamente a hora de saída da reunião.");
      return;
    }

    // Chamada da API
    UI.loader("show", "Um momento...");
    API.post("/reunioes", data)
      .then(
        function (json) {
          if (json.success) {
            this.setState({ reuniao: json.data });
          }
          UI.alert(json.success, json.message);
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  adicionarValor() {
    let index = this.state.reuniao.valores.findIndex((value, index, obj) => {
      return parseInt(value.usuarioId) === parseInt(this.state.usuarioId);
    });
    if (index >= 0) {
      UI.alert(
        false,
        "O profissional que você quer incluir já esta na lista de participantes desta reunião."
      );
      return;
    }

    index = this.state.procedimentos.findIndex((value, index, obj) => {
      return parseInt(value.id) === parseInt(this.state.reuniao.procedimentoId);
    });
    if (index >= 0) {
      let procedimento = this.state.procedimentos[index];
      index = procedimento.valores.findIndex((value, index, obj) => {
        return parseInt(value.usuarioId) === parseInt(this.state.usuarioId);
      });
      if (index >= 0) {
        let valor = procedimento.valores[index];
        let valorAdd = {
          usuarioId: valor.usuarioId,
          usuarioNome: valor.usuarioNome,
          unidade: valor.unidade,
          valorPagar: valor.valorPagar,
        };
        let reuniao = this.state.reuniao;
        reuniao.valorReceber = procedimento.valorReceber;
        reuniao.valores.push(valorAdd);
        this.setState({ reuniao: reuniao });
        return;
      }
    }
    UI.alert(
      false,
      "O profissional selecionado não pode participar deste tipo de atividade / reunião."
    );
  }

  removerValor(usuarioId) {
    let reuniao = this.state.reuniao;
    reuniao.valores = reuniao.valores.filter((value, index, obj) => {
      return usuarioId !== value.usuarioId;
    });
    this.setState({ reuniao: reuniao });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeReuniao(event) {
    let reuniao = this.state.reuniao;
    reuniao[event.target.name] = event.target.value;
    if (event.target.name === "procedimentoId") {
      let proc = this.state.procedimentos.find((val) => {
        return parseInt(reuniao.procedimentoId) === val.id;
      });
      reuniao.unidade = proc ? proc.unidade : 1;
      reuniao.valores = [];
      reuniao.valorReceber = "0.00";
    }
    this.setState({ reuniao: reuniao });
  }

  adicionarTopico() {
    let reuniao = this.state.reuniao;
    reuniao.topicos.push({ descricao: "" });
    this.setState({ reuniao: reuniao });
  }

  alterarTopico(index, value) {
    let reuniao = this.state.reuniao;
    reuniao.topicos[index].descricao = value;
    this.setState({ reuniao: reuniao });
  }

  removerTopico(index) {
    let reuniao = this.state.reuniao;
    let topicos = reuniao.topicos.filter((value, i, arr) => {
      return i !== index;
    });
    reuniao.topicos = topicos;
    this.setState({ reuniao: reuniao });
  }

  uploaded(documento) {
    let reuniao = this.state.reuniao;
    reuniao.documentos.push(documento);
    this.setState({ reuniao: reuniao });
  }

  render() {
    if (this.state.procedimentos.length === 0) return false;
    return (
      <React.Fragment>
        <form
          className="form-sample"
          autoComplete="off"
          spellCheck="false"
          onSubmit={this.handleSubmit}
        >
          <div className="row">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      {this.state.reuniao.id === 0 && (
                        <h4 className="card-title">NOVO ATIVIDADE / REUNIÃO</h4>
                      )}
                      {this.state.reuniao.id !== 0 && (
                        <h4 className="card-title">
                          CADASTRO ATIVIDADE / REUNIÃO #{this.state.reuniao.id}
                        </h4>
                      )}
                    </div>
                    {this.state.reuniao.id !== 0 && (
                      <div className="col-md-6 text-right">
                        <button
                          onClick={() => {
                            this.props.history.push(
                              "/reuniao/auditoria/" + this.state.reuniao.id
                            );
                          }}
                          className="btn btn-info"
                        >
                          <i className="fa fa-clock-o" />
                          &nbsp;Auditoria
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label>Cód / Procedimento *</label>
                      <select
                        name="procedimentoId"
                        className="form-control"
                        value={this.state.reuniao.procedimentoId}
                        onChange={this.handleChangeReuniao}
                      >
                        {this.state.procedimentos.map(function (
                          procedimento,
                          i
                        ) {
                          return (
                            <option
                              key={procedimento.id}
                              value={procedimento.id}
                            >
                              {procedimento.codigo +
                                " - " +
                                procedimento.descricao}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-3">
                      <label>Profissionais Disponíveis</label>
                      <div className="input-group">
                        <select
                          name="usuarioId"
                          className="form-control"
                          value={this.state.usuarioId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(function (usuario, i) {
                            return (
                              <option key={usuario.id} value={usuario.id}>
                                {usuario.nome}
                              </option>
                            );
                          })}
                        </select>
                        <div className="input-group-append">
                          <button
                            className="btn btn-xs btn-primary"
                            type="button"
                            onClick={this.adicionarValor}
                          >
                            Incluir
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <label>
                        Participantes *{" "}
                        <i className="light-description">
                          (clique para remover)
                        </i>
                      </label>
                      <div className="badge-background">
                        {this.state.reuniao.valores.length === 0 && (
                          <div className="badge badge-none">
                            Nenhum profissional foi selecionado...
                          </div>
                        )}
                        {this.state.reuniao.valores.map((valor) => {
                          return (
                            <div
                              key={valor.usuarioId}
                              onClick={() => {
                                this.removerValor(valor.usuarioId);
                              }}
                              className="badge badge-warning badge-remove"
                            >
                              <i className="icon icon-user" />
                              &nbsp;{valor.usuarioNome}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-3">
                      <label>Data *</label>
                      <InputMask
                        placeholder="DATA"
                        name="data"
                        className="form-control"
                        mask="99/99/9999"
                        value={this.state.reuniao.data}
                        onChange={this.handleChangeReuniao}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Hora Entrada *</label>
                      <InputMask
                        placeholder="HORA ENTRADA"
                        name="horaEntrada"
                        className="form-control"
                        mask="99:99"
                        value={this.state.reuniao.horaEntrada}
                        onChange={this.handleChangeReuniao}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Hora Saída *</label>
                      <InputMask
                        placeholder="HORA SAIDA"
                        name="horaSaida"
                        className="form-control"
                        mask="99:99"
                        value={this.state.reuniao.horaSaida}
                        onChange={this.handleChangeReuniao}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Reunião</label>
                      <select
                        name="tipo"
                        className="form-control"
                        value={this.state.reuniao.tipo}
                        onChange={this.handleChangeReuniao}
                      >
                        <option value={1}>CONFIRMADA</option>
                        <option value={2}>CANCELADA</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-md-12">
                      <label>Pauta *</label>
                      <input
                        placeholder="PAUTA"
                        name="pauta"
                        className="form-control"
                        value={this.state.reuniao.pauta}
                        onChange={this.handleChangeReuniao}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CadastroTopico
            topicos={this.state.reuniao.topicos}
            onAdicionarTopico={this.adicionarTopico}
            onAlterarTopico={this.alterarTopico}
            onRemoverTopico={this.removerTopico}
          />
          <CadastroObservacao
            observacoes={this.state.reuniao.observacoes}
            onChange={this.handleChangeReuniao}
          />
        </form>
        {this.state.reuniao.id !== 0 && (
          <CadastroDocumento
            reuniao={this.state.reuniao}
            documentos={this.state.reuniao.documentos}
            onUploaded={this.uploaded}
          />
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(CadastroReuniao);
